export default "__VITE_ASSET__BEq5Ingy__"